import React from "react";
import { Badge } from "@/components/catalyst/badge";
import classNames from "classnames";

export function Tag({
  children,
  className,
  icon,
}: {
  children: React.ReactNode;
  className?: string;
  icon?: React.ReactNode;
}) {
  return (
    <Badge
      color="zinc"
      title={
        children.toString() === "DRI" ? "Directly Responsible Individual" : ""
      }
      className={classNames({ className }, "text-xs capitalize sm:text-sm")}
    >
      {icon}
      {children}
    </Badge>
  );
}
